import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import { Button, Container } from '@material-ui/core';
import styles from './styles';
import useTranslation from '../../../hooks/useTranslation';

const SITE_LINK = process.env.REACT_APP_SHARE_ICON_LINK;

const WhatWeOffer = (props) => {
  const { classes } = props;
  const { t } = useTranslation();

  return (
    <div className={classes.aboutUsContainer}>
      <Container maxWidth="lg">
        <Grid container spacing={0}>
          <Grid item xs={12} md={5} lg={4}>
            <div className={classes.aboutUsLeftBox}>
              <h3 className={classes.aboutUsHeading}>{t('whatWeOffer')}</h3>
              <p className={classes.aboutUsText}>
                {t('whatWeOfferText')}
              </p>
              <Button
                variant="outlined"
                className={classes.exploreButton}
                href={`${SITE_LINK}what-we-offer`}
              >
                {t('exploreWhatWeOffer')}
                <i className="fas fa-arrow-right" style={{ marginLeft: '8px' }} />
              </Button>
            </div>
          </Grid>
          <Grid item xs={12} md={7} lg={8}>
            <div className={classes.aboutUsRightBox}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <ul className={classes.aboutUsList}>
                    <li><a href={`${SITE_LINK}what-we-offer?solution=theory-of-change-development`} rel="noopener noreferrer">{t('theoryOfChange')}</a></li>
                    <li><a href={`${SITE_LINK}what-we-offer?solution=evidence-synthesis`} rel="noopener noreferrer">{t('evidenceSynthesis')}</a></li>
                    <li><a href={`${SITE_LINK}what-we-offer?solution=impact-evaluations-scoping-and-design`} rel="noopener noreferrer">{t('impactEvalScoping')}</a></li>
                    <li><a href={`${SITE_LINK}what-we-offer?solution=research-grants-administration`} rel="noopener noreferrer">{t('researchGrantsAdmin')}</a></li>
                  </ul>
                </Grid>
                <Grid item xs={12} sm={6} className={classes.aboutUsRightCol}>
                  <ul className={classes.aboutUsList}>
                    <li><a href={`${SITE_LINK}what-we-offer?solution=impact-evaluation`} rel="noopener noreferrer">{t('impactEvaluation')}</a></li>
                    <li><a href={`${SITE_LINK}what-we-offer?solution=evidence-gap-maps`} rel="noopener noreferrer">{t('egm')}</a></li>
                    <li><a href={`${SITE_LINK}what-we-offer?solution=training-initiatives`} rel="noopener noreferrer">{t('trainingInitiatives')}</a></li>
                    <li><a href={`${SITE_LINK}what-we-offer?solution=transparency-research-and-ethics-helpdesk`} rel="noopener noreferrer">{t('treHelpdesk')}</a></li>
                  </ul>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

WhatWeOffer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(WhatWeOffer);
